import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  drawerPaper: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper
  },
  root: { display: 'flex', flexDirection: 'column' },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  searchField: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  priceSection: {
    marginBottom: theme.spacing(3)
  },
  slider: {
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2)
  },
  section: {
    marginBottom: theme.spacing(3)
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1)
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column'
  },
  checkboxLabel: {
    marginBottom: theme.spacing(0.5)
  },
  clearBtn: {
    color: theme.palette.info.main,
    cursor: 'pointer',
    fontWeight: 600,
    marginRight: theme.spacing(1)
  },
  filterTitle: {
    fontWeight: 600,
    fontSize: 20,
    color: theme.palette.grey[800]
  },
  switchLabel: { fontSize: 14, fontWeight: 600, marginLeft: 8 },
  switchContainer: { margin: '8px 0' },
  filterText: { fontWeight: 600, color: theme.palette.grey[800] },
  ratingForm: { marginTop: 10 },
  starRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  check: { marginRight: 4 },
  checkbox: {
    padding: 5
  }
}))

export default useStyles
